// ** Gatsby
import Container from "../../Container"
import Box from "../../Box"
import Heading from "../../Heading"
import Button from "../../Button"
import { GatsbyImage } from "gatsby-plugin-image"
import Text from "../../Text"
import SectionLink from "../../SectionLink"

const SectionCTA = ({ section }: any) => {
  const { Heading: heading, tagline, background, linkPrimary, tags } = section

  return (
    <Container
      className={`order-last flex flex-col w-full ${
        tags.includes("only-cta") ? "" : "lg:flex-row-reverse"
      } gap-10`}
      fullWidthOnMobile={false}
      constrainedToBreakPoint
    >
      {tags.includes("only-cta") ? (
        <Box className="flex flex-col mt-4 items-center">
          <SectionLink link={linkPrimary}>
            <Button className="bg-orange-500 max-w-max mt-4 lg:mt-8 text-white lg:fluid-lg py-4 px-8">
              {linkPrimary?.title}
            </Button>
          </SectionLink>
        </Box>
      ) : (
        <Box className="gap-0 rounded-[20px] overflow-hidden isolate shadow-md flex w-full flex-col lg:flex-row-reverse">
          <Box className="w-full lg:w-1/2">
            <GatsbyImage
              image={background?.Image?.asset?.gatsbyImageData}
              alt={background?.Image?.asset?.altText || "cover"}
              objectFit="cover"
              className="h-full w-full"
            />
          </Box>
          <Box className="w-full lg:w-1/2 px-2 py-4 lg:p-10 bg-blue-500">
            <Box className="flex flex-col items-center lg:items-start">
              <Heading
                as="h2"
                className="text-white !font-bold mb-2 text-center lg:text-left"
              >
                {heading}
              </Heading>
              <Text
                variant="small"
                className="text-white text-center lg:text-left mt-4 lg:mt-8"
              >
                {tagline}
              </Text>
            </Box>
            <Box className="flex flex-col mt-4 items-center lg:items-start">
              <SectionLink link={linkPrimary}>
                <Button className="bg-orange-500 max-w-max mt-4 lg:mt-8 text-white lg:fluid-lg py-4 px-8">
                  {linkPrimary?.title}
                </Button>
              </SectionLink>
            </Box>
          </Box>
        </Box>
      )}
    </Container>
  )
}

export default SectionCTA
